import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { QuillTemplate, QuillTemplateLocation } from '../../../generated/graphql.generated';
import { FreyaCommonModule } from '../../freya-common/freya-common.module';
import { commentDefaultToolbar } from '../../jobsv2/job-activity/comments.utils';
import { TEMPLATE_VARIABLES } from '../../jobsv2/job-activity/quill-modules/quill-templates.helpers';
import { VariableToolbarQuillModule } from '../../jobsv2/job-activity/quill-modules/variableToolbar.quillModule';
import { TEMPLATES_WITH_SUBJECT } from '../state/templates.store';

@Component({
    selector: 'app-mutate-template',
    standalone: true,
    imports: [FreyaCommonModule, QuillEditorComponent],
    templateUrl: './mutate-template.component.html',
    styleUrl: './mutate-template.component.scss'
})
export class MutateTemplateComponent implements OnInit {
    @ViewChild('editor', { static: false }) editor: QuillEditorComponent | undefined;
    @ViewChild('subjectEditor', { static: false }) subjectEditor: QuillEditorComponent | undefined;

    isEditMode = false;

    template: QuillTemplate = {
        id: null,
        name: '',
        contents: '',
        subjectContents: '',
        location: QuillTemplateLocation.GenericJobComment,
    };

    templateLocations = Object.values(QuillTemplateLocation).map(location => ({
        label: location.replaceAll('_', ' ').toLocaleLowerCase(),
        value: location,
    }));

    modules = {
        toolbar: commentDefaultToolbar,
        variableToolbar: true,
    };

    templatesWithSubjectContents = TEMPLATES_WITH_SUBJECT;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

    ngOnInit(): void {
        const template = structuredClone(this.config.data.template);
        if (template){
            this.template = template;

            this.isEditMode = Boolean(template.id);
        }
    }

    save(): void {
        this.ref.close({ ...this.template});
    }

    cancel(): void {
        this.ref.close();
    }

    onEditorCreated() {
        this.onTemplateLocationChange({value: this.template.location, originalEvent: null,});
    }

    onTemplateLocationChange(event: DropdownChangeEvent) {
        if (!event.value) return;
        const templateVariables = TEMPLATE_VARIABLES[event.value];
        [this.editor, this.subjectEditor].forEach(editor => {
            const variableToolbar = editor?.quillEditor?.getModule('variableToolbar') as VariableToolbarQuillModule;
            variableToolbar?.updateVariables(templateVariables);
        });
    }
}
